import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Generic breadcrumbs component.
 * @param {Array<{label: string, to?: string, onClick?: () => void}>} links
 * @param {string} current - Current page label
 */
const BreadcrumbsNav = ({ links = [], current }) => (
  <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
    {links.map(({ label, to, onClick }) => (
      <Link
        key={label}
        component={to ? RouterLink : 'button'}
        underline="hover"
        color="inherit"
        to={to}
        onClick={onClick}
        sx={{ cursor: 'pointer' }}
      >
        {label}
      </Link>
    ))}
    <Typography color="text.primary">{current}</Typography>
  </Breadcrumbs>
);

export default BreadcrumbsNav;
